import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';

import { ErrorReaderModule } from '../../seds-form-field/pipes/error-reader/error-reader.module';
import { SedsFormFieldCoreModule } from '../../seds-form-field/seds-form-field-core/seds-form-field-core.module';
import { SedsFormFieldTextComponent } from './seds-form-field-text.component';

@NgModule({
  declarations: [SedsFormFieldTextComponent],
  imports: [
    CommonModule,
    ErrorReaderModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    SedsFormFieldCoreModule,
  ],
  exports: [SedsFormFieldTextComponent, MatInput],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SedsFormFieldTextModule {}
